/** Raíz de las query keys de Cohorts. Va sola para que Segmentos la invalide sin un ciclo de imports. */
export const COHORTS_KEY = 'cohorts';
